import { render, staticRenderFns } from "./ModalShopPrices.vue?vue&type=template&id=d4bd9ad8&scoped=true"
import script from "./ModalShopPrices.vue?vue&type=script&lang=js"
export * from "./ModalShopPrices.vue?vue&type=script&lang=js"
import style0 from "./ModalShopPrices.vue?vue&type=style&index=0&id=d4bd9ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd9ad8",
  null
  
)

export default component.exports